import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames } from '@progress/kendo-react-common';
/**
 * The KendoReact ActionSheetItem component.
 */
export var ActionSheetItem = function (props) {
    var itemRef = React.useRef(null);
    var onClick = React.useCallback(function (event) {
        if (props.onClick) {
            props.onClick.call(undefined, {
                syntheticEvent: event,
                item: props.item,
                title: props.title
            });
        }
    }, [props.item, props.title, props.onClick]);
    React.useEffect(function () {
        if (itemRef.current && props.focused) {
            itemRef.current.focus();
        }
    }, [props.focused]);
    return (React.createElement("span", { style: props.style, tabIndex: props.tabIndex, className: classNames('k-actionsheet-item', 'k-cursor-pointer', props.disabled && 'k-disabled', props.className), ref: itemRef, role: "button", "aria-disabled": props.disabled, onClick: onClick },
        React.createElement("span", { className: "k-actionsheet-action" },
            props.icon && React.createElement("span", { className: "k-icon-wrap" }, props.icon),
            (props.title || props.description) && (React.createElement("span", { className: "k-actionsheet-item-text" },
                props.title && React.createElement("span", { className: "k-actionsheet-item-title" }, props.title),
                props.description && React.createElement("span", { className: "k-actionsheet-item-description" }, props.description))))));
};
ActionSheetItem.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    description: PropTypes.string,
    disabled: PropTypes.bool,
    group: PropTypes.oneOf(['top', 'bottom']),
    icon: PropTypes.element,
    title: PropTypes.string
};
